/*eslint-disable*/
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { toPng } from 'html-to-image';
import { setErrorNotification } from '../../../../redux/slices/NotificationSlice';
import ModalBox from '../../../../shared/component/ModalBox';
import TemplateContentUpload from '../TemplateContentUpload';
import HtmlHeader from '../HtmlHeader';
import utils from '../templateFunctions';
import { createOrUpdateTemplate } from '../../../../redux/slices/TemplateSlice';
import FileFormat from '../FileFormat';
import PopupBox from '../ContentUploadConfirmation';

function HtmlTemplateTwenty({ templateData }) {
 const [data, setData] = useState([]);
 const [notification, setNotification] = useState(false);
 const [
  openContentUploadConfirmation,
  setOpenContentUploadConfirmation,
 ] = useState(false);
 const [base64, setBase64] = useState('');
 const [htmlContent, setHtmlContent] = useState('');
 const [disable, setDisable] = useState(true);
 const [modalView, setModalView] = useState({ content: '', title: '' });
 const { t } = useTranslation();
 const dispatch = useDispatch();
 const htmlRef = useRef(null);
 const cssStyles = `
body {
    margin: 0;
    padding: 0;
}
@font-face {
 font-family: "Urbanist";
 src: url(../../../assets/fonts/urbanist/Urbanist-Bold.ttf) format("truetype");
 font-weight: 700;
}

@font-face {
 font-family: "Urbanist";
 src: url(../../../assets/fonts/urbanist/Urbanist-Medium.ttf) format("truetype");
 font-weight: 500;
}

@font-face {
 font-family: "Urbanist";
 src: url(../../../assets/fonts/urbanist/Urbanist-Regular.ttf) format("truetype");
 font-weight: 400;
}

@font-face {
 font-family: "Great Vibes";
 src: url(../../../assets/fonts/greatVibes/GreatVibes-Regular.ttf) format("truetype");
 font-weight: 500;
}
.pet-banner {
 position: relative;
 width: 100%;
 height: 94vh;
 background: linear-gradient(170deg, #f8e86b 60%, #6d3fa0 60%);
 overflow: hidden;
 font-family: "Poppins", sans-serif;
}

.pet-banner::after {
 content: "";
 position: absolute;
 left: 20%;
 bottom: 0;
 width: 100%;
 height: 500px;
 background-color: #6d3fa0;
 display: flex;
 justify-content: center;
 align-items: flex-end;
 flex-direction: column;
 clip-path: path("M0,154 C200,158 394,0 800,120 C1000,180 1200,80 1440,120 L1440,500 L0,500 Z");
}

/* 🦴 Circle image */
.pet-banner__circle-image {
 position: absolute;
 top: 6%;
 left: 40%;
 width: 180px;
 height: 180px;
 border-radius: 50%;
 border: 5px solid #6d3fa0;
 overflow: hidden;
 z-index: 3;
}
.pet-banner__circle-image img {
 width: 100%;
 height: 100%;
 object-fit: cover;
}

/* 🟣 PET STORE + button */
.pet-banner__text-section {
 position: absolute;
 top: 5%;
 right: 20%;
 display: flex;
 flex-direction: column;
 align-items: flex-end;
 width: 100%;
}

.pet-banner__title {
 color: #6d3fa0;
 font-size: 2.8rem;
 font-weight: 800;
 margin-bottom: 40px;
}

.pet-banner__button {
 background: transparent;
 border: 2px solid #6d3fa0;
 color: #6d3fa0;
 font-weight: 600;
 font-size: 1rem;
 padding: 12px 32px;
 border-radius: 6px;
 cursor: pointer;
 transition: all 0.3s ease;
 z-index: 2;
 position: absolute;
 right: 30%;
 top: 270px;
}
.pet-banner__button:hover {
 background-color: #6d3fa0;
 color: #fff;
}

/* 🐶 Dog Section */
.pet-banner__dog-section {
 position: absolute;
 bottom: 25%;
 right: 25%;
 display: flex;
 flex-direction: column;
 align-items: center;
 z-index: 5;
}

.pet-banner__dog {
 width: 260px;
 height: auto;
 position: relative;
 z-index: 2;
}

/* 💭 Thought bubbles */
.pet-banner__thought {
 position: absolute;
 top: -50px;
 right: 200px;
 display: flex;
 flex-direction: column;
 align-items: center;
 transform: rotate(-46deg);
}

.pet-banner__thought .bubble {
 background-color: #6d3fa0;
 border-radius: 50%;
 margin-bottom: 8px;
}

.pet-banner__thought .bubble--small {
 width: 12px;
 height: 12px;
}

.pet-banner__thought .bubble--medium {
 width: 20px;
 height: 20px;
}

.pet-banner__thought .bubble--large {
 width: 30px;
 height: 30px;
}

/* ✍️ "I WANT FOOD" text */
.pet-banner__dog-text {
 font-family: "Patrick Hand", "Comic Sans MS", cursive;
 color: #f8e86b;
 font-size: 1.6rem;
 font-weight: 700;
 margin-top: 18px;
 letter-spacing: 2px;
 position: relative;
 text-align: center;
}

.pet-banner__dog-text::before,
.pet-banner__dog-text::after {
 content: "";
 position: absolute;
 top: -12px;
 width: 25px;
 height: 3px;
 background-color: #6d3fa0;
 border-radius: 3px;
}

.pet-banner__dog-text::before {
 left: -35px;
 transform: rotate(-20deg);
}

.pet-banner__dog-text::after {
 right: -35px;
 transform: rotate(20deg);
}

/* ✨ Floating yellow dots */
.pet-banner .dot {
 position: absolute;
 background-color: #f9e872;
 border-radius: 50%;
 z-index: 1;
}

.pet-banner .dot--1 {
 top: 160px;
 left: 280px;
 width: 20px;
 height: 20px;
}

.pet-banner .dot--2 {
 bottom: 200px;
 left: 100px;
 width: 14px;
 height: 14px;
}

.pet-banner .dot--3 {
 top: 260px;
 left: 450px;
 width: 10px;
 height: 10px;
}

/* ⚡ Zigzag decorations */
.pet-banner .zigzag {
 position: absolute;
 width: 80px;
 height: 6px;
 background: repeating-linear-gradient(
   90deg,
   transparent,
   transparent 6px,
   #6d3fa0 6px,
   #6d3fa0 12px
 );
}

.pet-banner .zigzag--top-left {
 top: 30px;
 left: 40px;
 transform: rotate(0deg);
}

.pet-banner .zigzag--bottom-left {
 bottom: 140px;
 left: 40px;
 transform: rotate(0deg);
}

.pet-banner .zigzag--right {
 top: 180px;
 right: 100px;
 transform: rotate(180deg);
}

/* 📱 Responsive adjustments */
@media (max-width: 768px) {
 .pet-banner {
   height: 500px;
   background: linear-gradient(140deg, #f8e86b 55%, #6d3fa0 55%);
 }

 .pet-banner__circle-image {
   top: 50px;
   left: 40px;
   width: 130px;
   height: 130px;
 }

 .pet-banner__title {
   font-size: 2rem;
 }

 .pet-banner__dog {
   width: 200px;
 }

 .pet-banner__thought {
   right: 140px;
   top: -100px;
 }
}
  `;

 const convertImage = async (url) => {
  await utils
   .convertSignedUrl(url)
   .then((response) => {
    setDisable(false);
    dispatch(createOrUpdateTemplate(response));
   })
   .catch((error) => {
    setDisable(false);
    dispatch(setErrorNotification(error?.response?.data));
   });
 };

 const convertBase64 = async () => {
  try {
   // Convert to base64
   const dataUrl = await toPng(htmlRef.current, { cacheBust: true });
   setBase64(dataUrl); // Set the base64 data
   convertImage(dataUrl); // Your function to handle the base64 data
  } catch (error) {
   dispatch(setErrorNotification(error?.response?.data));
  }
 };

 const convertHtml = () => {
  if (htmlRef.current) {
   const content = htmlRef.current.outerHTML;
   const fullHtml = `
        <html>
          <head>
              <link rel="preconnect" href="https://fonts.googleapis.com" />
              <link rel="preconnect" href="https://fonts.gstatic.com" />
              <link 
              href="https://fonts.googleapis.com/css2?family=Great+Vibes&family=Urbanist:wght@100..900&display=swap" 
              rel="stylesheet" />           
              <style>${cssStyles}</style>
          </head>
          <body>${content}</body>
        </html>
      `;
   setHtmlContent(fullHtml); // Set the HTML content as a string
  }
 };

 useEffect(() => {
  utils?.initializer(templateData).then((res) => setData(res));
  utils?.reload();
 }, [templateData]);

 /* useEffect runs convertBase64 after data is updated */
 useEffect(() => {
  if (data) {
   setTimeout(() => {
    convertBase64();
   }, 1000);
   convertHtml();
  }
 }, [data]);

 const handleFileType = (fileType) => {
  setModalView({
   title: 'content',
   content: (
    <TemplateContentUpload
     base64={base64}
     setNotification={setNotification}
     fileType={fileType}
     htmlContent={htmlContent}
    />
   ),
  });
 };

 const onClickContentUpload = () => {
  setNotification(true);
  setModalView({
   title: t('fileFormat'),
   content: (
    <FileFormat
     setNotification={setNotification}
     handleFileType={handleFileType}
     setOpenContentUploadConfirmation={setOpenContentUploadConfirmation}
     data={data}
    />
   ),
  });
 };
 const contentDetails = data?.[0]?.template_contents?.items?.[0]?.details?data?.[0]?.template_contents?.items?.[0]?.details :[];
 const styles = data?.[0]?.styles?.details;
 const backgroundColor = data?.[0]?.styles?.background;
 return (
  <div>
   <HtmlHeader
    htmlData={data}
    disable={disable}
    click={onClickContentUpload}
   />

   <ModalBox
    status={notification}
    closeModal={setNotification}
    modalView={modalView}
   />
   <ModalBox
    status={openContentUploadConfirmation}
    closeModal={setOpenContentUploadConfirmation}
    modalView={{
     title: 'Confirmation',
     content: (
      <PopupBox
       setOpenContentUploadConfirmation={
        setOpenContentUploadConfirmation
       }
       setNotification={setNotification}
      />
     ),
    }}
   />
   <div className="header-height" />
   <div className="pet-banner" style={{background:backgroundColor}}  ref={htmlRef}>
      {/* Decorative dots */}
      <span className="dot dot--1"></span>
      <span className="dot dot--2"></span>
      <span className="dot dot--3"></span>

      {/* Zigzag lines */}
      <div className="zigzag zigzag--top-left"></div>
      <div className="zigzag zigzag--bottom-left"></div>
      <div className="zigzag zigzag--right"></div>

      {/* Circle image */}
      <div className="pet-banner__circle-image">
        <img src={contentDetails?.[0]?.image} alt="dog biscuits" />
      </div>

      {/* Title & Button */}
      <div className="pet-banner__text-section">
     <h2 className="pet-banner__title"
      style={{
       fontSize: styles?.[0]?.fontSize,
       fontFamily: styles?.[0]?.fontFamily,
       color: styles?.[0]?.color
      }}>
      {contentDetails?.[0]?.heading}
     </h2>
        <button className="pet-banner__button">{contentDetails?.[0]?.name}</button>
      </div>

      {/* Dog and thought bubble */}
      <div className="pet-banner__dog-section">
        <img src={contentDetails?.[0]?.image}  alt="Dog" className="pet-banner__dog" />

        <div className="pet-banner__thought">
          <span className="bubble bubble--small"></span>
          <span className="bubble bubble--medium"></span>
          <span className="bubble bubble--large"></span>
        </div>

     <p className="pet-banner__dog-text" style={{
       fontSize: styles?.[1]?.fontSize,
       fontFamily: styles?.[1]?.fontFamily,
       color: styles?.[1]?.color
      }}>{contentDetails?.[0]?.description}</p>
      </div>
    </div>
   </div>
 );
}
 HtmlTemplateTwenty.propTypes = {
  templateData: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    template_name: PropTypes.string.isRequired,
  }).isRequired,
  // Ensure templateData is an array of objects with specific shape
};

export default HtmlTemplateTwenty;